import React from 'react';
import styled from 'styled-components';

export const ItemListFooter = ({ markShopper, shopper, listIndex, list }) => {
  return (
    <>
      {shopper && (
        <Flex>
          <Button
            onClick={() => markShopper(0, list.id, listIndex)}
            color={
              shopper[0]
                ? 'var(--theme-secondary-color)'
                : 'var(--theme-secondary-color)'
            }
            fontWeight={shopper[0] ? 'bold' : 'initial'}
          >
            My turn
          </Button>
          <Button
            onClick={() => markShopper(1, list.id, listIndex)}
            color={
              shopper[1]
                ? 'var(--theme-secondary-color)'
                : 'var(--theme-secondary-color)'
            }
            fontWeight={shopper[1] ? 'bold' : 'initial'}
          >
            Your turn
          </Button>
          <Button
            onClick={() => markShopper(2, list.id, listIndex)}
            color={
              shopper[2]
                ? 'var(--theme-secondary-color)'
                : 'var(--theme-secondary-color)'
            }
            fontWeight={shopper[2] ? 'bold' : 'initial'}
          >
            Let's all go
          </Button>
        </Flex>
      )}
    </>
  );
};

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Button = styled.button`
  background: none;
  border: none;
  font-size: 1rem;
  padding: 15px 20px;
  color: ${props => props.color || 'initial'};
  font-weight: ${props => props.fontWeight || 'initial'};
  cursor: pointer;

  &.active {
    color: var(--theme-secondary-color);
    font-weight: bold;
  }

  @media (max-width: 480px) {
    font-size: 0.7rem;
  }
`;
